import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, DatePicker } from "antd";
import { TipoDocumentoSelect } from "../../configuraciones/TipoDocumentoSelect";
import {
  DateFormats,
  TipoDocumentoPersonaConstants,
} from "../../../types/typesConstants";
import { SwitchUi } from "../../ui/SwitchUi";
import { FormItemHiddenUi } from "../../ui/FormItemHiddenUi";
import { messageError, messageInfo } from "../../../helpers";
import { get_api_datospersona } from "../../../actions";
export const ClientePrincipalPart = () => {
  const form = Form.useFormInstance();
  const tipodocumento = Form.useWatch("tipodocumento", form);
  const [visible, setVisible] = useState(false);
  const [maxlength, setMaxlength] = useState(25);
  const clearFieldsSearch = () => {
    form.setFieldsValue({
      nombrecompleto: null,
      nombres: null,
      apepaterno: null,
      apematerno: null,
    });
  };
  const ChangeTipoDocumento = (tipodocumento) => {
    const itipodocumento = parseInt(tipodocumento);
    switch (itipodocumento) {
      case parseInt(TipoDocumentoPersonaConstants.Ruc):
        setVisible(true);
        setMaxlength(11);
        break;
      case parseInt(TipoDocumentoPersonaConstants.Dni):
        setMaxlength(8);
        setVisible(false);
        break;
      default:
        setVisible(false);
        setMaxlength(25);
        break;
    }
  };
  const onHandleChangeTipoDocumento = (tipodocumento) => {
    clearFieldsSearch();
    ChangeTipoDocumento(tipodocumento);
  };
  const onChangePersona = (e) => {
    form.setFieldValue("nrodocumento", e.target.value);
  };
  const searchPersona = async (nrodocumento, e) => {
    e.preventDefault();
    try {
      await form.validateFields(["nrodocumento"]);
      if (!!tipodocumento && !!nrodocumento) {
        const datosPersona = await get_api_datospersona({
          tipodocumento,
          nrodocumento,
        });
        if (datosPersona) {
          const itipodocumento = parseInt(tipodocumento);
          if (itipodocumento === TipoDocumentoPersonaConstants.Ruc) {
            form.setFieldsValue({
              ...datosPersona,
              nombres: null,
              apepaterno: null,
              apematerno: null,
              fechanacimiento: null,
            });
          } else {
            form.setFieldsValue({
              ...datosPersona,
            });
          }
        } else {
          clearFieldsSearch();
          messageInfo("No existe datos con el filtro ingresado");
        }
      } else messageInfo("Seleccione o ingrese el tipo y número de documento");
    } catch (error) {
      messageError(error);
    }
  };
  // useEffect(() => {
  //   const _tipodocumento = form.getFieldValue("tipodocumento");
  //   ChangeTipoDocumento(_tipodocumento);
  // }, []);

  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
          <Form.Item
            label="Tipo Documento"
            name="tipodocumento"
            className="mb-1"
            rules={[
              {
                required: true,
                message: "El tipo de documento es obligatorio",
              },
            ]}
          >
            <TipoDocumentoSelect
              style={{ width: "100%" }}
              placeholder="[-Seleccione-]"
              onChange={onHandleChangeTipoDocumento}
              // disabled={values?.tipodocumento != ""}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item
            label="Número"
            name="nrodocumento"
            className="mb-1"
            rules={[
              {
                required: true,
                message: "El número documento es obligatorio",
              },
              {
                min: 8,
                message:
                  "El número de documento tiene que ser de minimo 8 digitos",
              },
            ]}
          >
            <Input.Search
              placeholder="Buscar número documento"
              allowClear
              showCount
              maxLength={maxlength}
              enterButton
              onSearch={searchPersona}
              onChange={onChangePersona}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={10} lg={10} xl={10}>
          <Form.Item
            name="state"
            label="¿Está activo?"
            className="mb-1"
            valuePropName="checked"
          >
            <SwitchUi />
          </Form.Item>
        </Col>
      </Row>
      {visible && (
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <Form.Item name="nombrecompleto" label="Razón Social">
              <Input placeholder="Razón social" />
            </Form.Item>
          </Col>
        </Row>
      )}
      {!visible && (
        <>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item name="nombres" label="Nombres">
                <Input placeholder="Nombres" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="apepaterno" label="Ape.Paterno">
                <Input placeholder="Apellido Paterno" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="apematerno" label="Ape.Materno">
                <Input placeholder="Apellido Materno" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={10} xl={8}>
              <Form.Item name="fechanacimiento" label="Fecha Nacimiento">
                <DatePicker format={DateFormats.frontend} />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
